import { Box, Card, CardHeader, CardHeaderTypeMap } from '@mui/material';
// eslint-disable-next-line import/no-unresolved
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AppPrimaryButton } from 'shared/components/AppComponents';
import { BaseApplicationState } from 'state/baseapplication/Reducer';

// eslint-disable-next-line @typescript-eslint/ban-types
type CardMember = OverridableComponent<CardHeaderTypeMap<{}, 'div'>>;

const CardEmployeeManage: CardMember = CardHeader;

const AdministrationCard: React.FC<any> = () => {
  const navigate = useNavigate();
  const { orgACLConfig }: BaseApplicationState = useSelector(
    (state: any) => state.baseAppState
  );
  return (
    <Box className="administration-wrapper">
      <Card variant="outlined">
        <CardHeader title="Administration" />
        <CardEmployeeManage
          title="Risk Tier Approvers"
          subheader="Manage users who can approve or unapprove AI solutions."
          action={
            orgACLConfig.settings?.includes(
              'settings.management.manageRiskTierApprovers'
            ) && (
              <AppPrimaryButton
                title="Manage Risk Tier Approvers"
                sx={{ background: '#06362b !important' }}
                onClick={() => {
                  navigate('/tier-approvers');
                }}
              />
            )
          }
        />
        <CardEmployeeManage
          title="Data Sensitivity Types"
          subheader="Manage configurable data sensitivity classifications."
          action={
            orgACLConfig.settings?.includes(
              'settings.management.manageDataSensitivityTypes'
            ) && (
              <AppPrimaryButton
                title="Manage Data Sensitivity Types"
                sx={{ background: '#06362b !important' }}
                onClick={() => {
                  navigate('/sensitivity-types');
                }}
              />
            )
          }
        />
      </Card>
    </Box>
  );
};

export default AdministrationCard;
